import L from "leaflet";
import type { PinCategory } from "../types";
import type { PinVisit } from "../lib/questMapState";

import markerIcon2x from "leaflet/dist/images/marker-icon-2x.png";
import markerIcon from "leaflet/dist/images/marker-icon.png";
import markerShadow from "leaflet/dist/images/marker-shadow.png";

delete (L.Icon.Default.prototype as unknown as { _getIconUrl?: unknown })
  ._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2x,
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
});

export const PIN_COLORS: Record<PinCategory, string> = {
  lodging: "#c45c26",
  transport: "#2f6f8f",
  coffee: "#b56a2b",
  food: "#a63d40",
  attraction: "#3d6b4f",
  flight: "#4a5568",
};

function coffeeCup(stroke: string) {
  return `<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="${stroke}" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 8h12v9a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4V8Zm12 1h2a3 3 0 1 1 0 6h-2M7 2v3m5-3v3"/></svg>`;
}

/** Outline until visited or active. Only the active pin is filled. */
export function makeIcon(
  category: PinCategory,
  dimmed = false,
  visit: PinVisit = "unvisited",
) {
  const color = PIN_COLORS[category] ?? "#5c4a3a";
  const filled = visit === "active";
  const opacity = dimmed ? 0.32 : 1;
  const size = dimmed ? 14 : category === "coffee" ? 22 : filled ? 20 : 18;
  const isCoffee = category === "coffee";
  const bg = filled ? color : "transparent";
  const border = filled ? "2px solid #fff8f0" : `2.5px solid ${color}`;
  const shadow = filled ? "0 2px 8px rgba(0,0,0,0.35)" : "none";
  const filter = visit === "visited" ? "grayscale(0.92) saturate(0.15)" : "none";
  const cup = isCoffee ? coffeeCup(filled ? "#fff8f0" : color) : "";
  const dot = `<span class="pin-dot${isCoffee ? " pin-dot-coffee" : ""}${filled ? " is-filled" : " is-outline"}${visit === "visited" ? " is-stamped" : ""}" style="background:${bg};opacity:${opacity};width:${size}px;height:${size}px;border:${border};box-shadow:${shadow};filter:${filter}">${cup}</span>`;
  const stamp =
    visit === "visited"
      ? `<span class="pin-stamp-badge" aria-hidden="true">✓</span>`
      : "";
  const box = size + 10;
  return L.divIcon({
    className: `pin-marker${isCoffee ? " pin-marker-coffee" : ""}${dimmed ? " is-dimmed" : ""} pin-visit-${visit}`,
    html: `<span class="pin-icon-wrap">${dot}${stamp}</span>`,
    iconSize: [box, box],
    iconAnchor: [box / 2, box / 2],
    popupAnchor: [0, -14],
  });
}

export function arrowIcon(bearing: number) {
  return L.divIcon({
    className: "hop-arrow-marker",
    html: `<span class="hop-arrow-glyph" style="transform:rotate(${bearing}deg)" aria-hidden="true"><svg width="16" height="16" viewBox="0 0 16 16"><path d="M8 1.2 12.6 13.2H9.1L8 15.4 6.9 13.2H3.4Z" fill="#304d3b"/></svg></span>`,
    iconSize: [18, 18],
    iconAnchor: [9, 9],
  });
}
